const config = {
  API_URL: "{{{API_URL}}}",
  AUTH_APP_ID: "{{{AUTH_APP_ID}}}",
  AUTH_REDIRECT_URI: "{{{AUTH_REDIRECT_URI}}}",
  AUTHORITY: "{{{AUTHORITY}}}",
  SCOPES: ["User.Read"],
}

export default config